import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { RegionalFocus } from '../components/RegionalFocus';
import { ArrowRightIcon, TrendingUpIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
export function RegionalFocusPage() {
  return <div className="w-full pt-20 lg:pt-24" data-id="element-524">
      {/* Page Header */}
      <div className="bg-navy py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-525">
        <div className="max-w-7xl mx-auto" data-id="element-526">
          <div className="font-sans text-sm font-semibold text-white/50 uppercase tracking-wider mb-4" data-id="element-527">
            <Link to="/" className="hover:text-gold transition-colors" data-id="element-528">
              Home
            </Link>
            <span className="mx-2 text-gold/50" data-id="element-529">/</span>
            <span className="text-gold" data-id="element-530">Regional Focus</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl text-white font-bold" data-id="element-531">
            Regional Focus
          </h1>
          <div className="h-1 w-24 bg-gold mt-6" data-id="element-532"></div>
        </div>
      </div>

      {/* Regional Focus Component */}
      <RegionalFocus data-id="element-533" />

      {/* Country Profiles */}
      <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-534">
        <div className="max-w-7xl mx-auto" data-id="element-535">
          <div className="text-center mb-16" data-id="element-536">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-537">
              Market Intelligence
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6" data-id="element-538">
              Country Profiles
            </h2>
            <div className="h-1 w-24 bg-gold mx-auto" data-id="element-539"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-540">
            {/* Nigeria Card */}
            <div className="bg-white rounded-card p-8 shadow-sm border border-cream-dark" data-id="element-541">
              <div className="flex items-center mb-6" data-id="element-542">
                <span className="text-4xl mr-4" role="img" aria-label="Flag of Nigeria" data-id="element-543">
                  🇳🇬
                </span>
                <h3 className="font-serif text-2xl text-navy font-bold" data-id="element-544">
                  Federal Republic of Nigeria
                </h3>
              </div>
              <p className="font-sans text-text-muted leading-relaxed mb-6" data-id="element-545">
                As Africa's largest economy and most populous nation, Nigeria
                offers unparalleled scale. Its dynamic tech ecosystem, vast
                natural resources, and rapidly growing middle class make it a
                critical anchor for any West African strategy.
              </p>
              <div className="space-y-4 border-t border-gray-100 pt-6" data-id="element-546">
                <div className="flex justify-between items-center" data-id="element-547">
                  <span className="font-sans font-semibold text-navy" data-id="element-548">
                    Population:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-549">220M+</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-550">
                  <span className="font-sans font-semibold text-navy" data-id="element-551">
                    GDP:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-552">$477B</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-553">
                  <span className="font-sans font-semibold text-navy" data-id="element-554">
                    Capital:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-555">
                    Abuja (Commercial Hub: Lagos)
                  </span>
                </div>
                <div className="flex justify-between items-start" data-id="element-556">
                  <span className="font-sans font-semibold text-navy" data-id="element-557">
                    Key Sectors:
                  </span>
                  <span className="font-sans text-text-muted text-right" data-id="element-558">
                    Oil & Gas, Tech, Agriculture, Finance
                  </span>
                </div>
              </div>
            </div>

            {/* Ghana Card */}
            <div className="bg-white rounded-card p-8 shadow-sm border border-cream-dark" data-id="element-559">
              <div className="flex items-center mb-6" data-id="element-560">
                <span className="text-4xl mr-4" role="img" aria-label="Flag of Ghana" data-id="element-561">
                  🇬🇭
                </span>
                <h3 className="font-serif text-2xl text-navy font-bold" data-id="element-562">
                  Republic of Ghana
                </h3>
              </div>
              <p className="font-sans text-text-muted leading-relaxed mb-6" data-id="element-563">
                Known for its political stability and strong institutional
                frameworks, Ghana serves as an ideal entry point and regional
                headquarters. It hosts the secretariat of the African
                Continental Free Trade Area (AfCFTA).
              </p>
              <div className="space-y-4 border-t border-gray-100 pt-6" data-id="element-564">
                <div className="flex justify-between items-center" data-id="element-565">
                  <span className="font-sans font-semibold text-navy" data-id="element-566">
                    Population:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-567">33M+</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-568">
                  <span className="font-sans font-semibold text-navy" data-id="element-569">
                    GDP:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-570">$77B</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-571">
                  <span className="font-sans font-semibold text-navy" data-id="element-572">
                    Capital:
                  </span>
                  <span className="font-sans text-text-muted" data-id="element-573">Accra</span>
                </div>
                <div className="flex justify-between items-start" data-id="element-574">
                  <span className="font-sans font-semibold text-navy" data-id="element-575">
                    Key Sectors:
                  </span>
                  <span className="font-sans text-text-muted text-right" data-id="element-576">
                    Mining, Cocoa, Digital Services, Energy
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AfCFTA Opportunity */}
      <section className="py-20 bg-navy text-white px-4 sm:px-6 lg:px-8" data-id="element-577">
        <div className="max-w-7xl mx-auto" data-id="element-578">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-579">
            <div data-id="element-580">
              <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-581">
                Trade Framework
              </span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-582">
                The AfCFTA Advantage
              </h2>
              <p className="font-sans text-lg text-white/80 leading-relaxed mb-6" data-id="element-583">
                The African Continental Free Trade Area (AfCFTA) represents the
                largest free trade area in the world by number of participating
                countries. With its secretariat headquartered in Accra, Ghana,
                it creates a single market of 1.3 billion people with a combined
                GDP of $3.4 trillion.
              </p>
              <p className="font-sans text-lg text-white/80 leading-relaxed mb-8" data-id="element-584">
                For US companies, this means unprecedented access to a unified
                African market through strategic entry points in Nigeria and
                Ghana. Emma Kay Consulting helps you navigate the evolving
                AfCFTA regulatory landscape to maximize your competitive
                position.
              </p>
              <div className="grid grid-cols-2 gap-6" data-id="element-585">
                <div className="border border-white/10 rounded-card p-5" data-id="element-586">
                  <div className="font-serif text-3xl font-bold text-gold mb-1" data-id="element-587">
                    54
                  </div>
                  <div className="font-sans text-xs text-white/60 uppercase tracking-wider" data-id="element-588">
                    Member Nations
                  </div>
                </div>
                <div className="border border-white/10 rounded-card p-5" data-id="element-589">
                  <div className="font-serif text-3xl font-bold text-gold mb-1" data-id="element-590">
                    $3.4T
                  </div>
                  <div className="font-sans text-xs text-white/60 uppercase tracking-wider" data-id="element-591">
                    Combined GDP
                  </div>
                </div>
                <div className="border border-white/10 rounded-card p-5" data-id="element-592">
                  <div className="font-serif text-3xl font-bold text-gold mb-1" data-id="element-593">
                    1.3B
                  </div>
                  <div className="font-sans text-xs text-white/60 uppercase tracking-wider" data-id="element-594">
                    Consumer Market
                  </div>
                </div>
                <div className="border border-white/10 rounded-card p-5" data-id="element-595">
                  <div className="font-serif text-3xl font-bold text-gold mb-1" data-id="element-596">
                    +52%
                  </div>
                  <div className="font-sans text-xs text-white/60 uppercase tracking-wider" data-id="element-597">
                    Projected Intra-Trade Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6" data-id="element-598">
              <motion.div className="bg-white/5 border border-white/10 rounded-card p-6" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} data-id="element-599">
                <TrendingUpIcon className="h-6 w-6 text-gold mb-3" data-id="element-600" />
                <h3 className="font-serif text-lg font-semibold mb-2" data-id="element-601">
                  Tariff Reduction
                </h3>
                <p className="font-sans text-sm text-white/70 leading-relaxed" data-id="element-602">
                  Progressive elimination of tariffs on 90% of goods, creating
                  significant cost advantages for companies with established
                  regional operations.
                </p>
              </motion.div>
              <motion.div className="bg-white/5 border border-white/10 rounded-card p-6" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-603">
                <ShieldCheckIcon className="h-6 w-6 text-gold mb-3" data-id="element-604" />
                <h3 className="font-serif text-lg font-semibold mb-2" data-id="element-605">
                  Regulatory Harmonization
                </h3>
                <p className="font-sans text-sm text-white/70 leading-relaxed" data-id="element-606">
                  Standardized customs procedures and mutual recognition
                  agreements that simplify cross-border operations between
                  member states.
                </p>
              </motion.div>
              <motion.div className="bg-white/5 border border-white/10 rounded-card p-6" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-607">
                <UsersIcon className="h-6 w-6 text-gold mb-3" data-id="element-608" />
                <h3 className="font-serif text-lg font-semibold mb-2" data-id="element-609">
                  Free Movement of Labor
                </h3>
                <p className="font-sans text-sm text-white/70 leading-relaxed" data-id="element-610">
                  Protocols enabling easier movement of business professionals,
                  making it simpler to build and manage regional teams.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Trade Corridors */}
      <section className="py-20 bg-cream-dark px-4 sm:px-6 lg:px-8" data-id="element-611">
        <div className="max-w-7xl mx-auto" data-id="element-612">
          <div className="text-center mb-16" data-id="element-613">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-614">
              Strategic Routes
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6" data-id="element-615">
              Key Trade Corridors
            </h2>
            <div className="h-1 w-24 bg-gold mx-auto" data-id="element-616"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-617">
            <div className="bg-white p-8 rounded-card shadow-sm border border-gray-100" data-id="element-618">
              <div className="flex items-center gap-3 mb-4" data-id="element-619">
                <span className="text-2xl" data-id="element-620">🇺🇸</span>
                <ArrowRightIcon className="h-4 w-4 text-gold" data-id="element-621" />
                <span className="text-2xl" data-id="element-622">🇳🇬</span>
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-3" data-id="element-623">
                US — Nigeria
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed mb-4" data-id="element-624">
                The largest bilateral trade relationship in Sub-Saharan Africa.
                Key sectors include energy, technology, agriculture, and
                financial services.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-625">
                <div className="font-serif text-2xl text-navy font-bold" data-id="element-626">
                  $10.1B
                </div>
                <div className="font-sans text-xs text-gray-500" data-id="element-627">
                  Annual Bilateral Trade
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-card shadow-sm border border-gray-100" data-id="element-628">
              <div className="flex items-center gap-3 mb-4" data-id="element-629">
                <span className="text-2xl" data-id="element-630">🇺🇸</span>
                <ArrowRightIcon className="h-4 w-4 text-gold" data-id="element-631" />
                <span className="text-2xl" data-id="element-632">🇬🇭</span>
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-3" data-id="element-633">
                US — Ghana
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed mb-4" data-id="element-634">
                A growing partnership anchored by AGOA trade preferences. Key
                sectors include mining, cocoa processing, digital services, and
                renewable energy.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-635">
                <div className="font-serif text-2xl text-navy font-bold" data-id="element-636">
                  $2.8B
                </div>
                <div className="font-sans text-xs text-gray-500" data-id="element-637">
                  Annual Bilateral Trade
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-card shadow-sm border border-gray-100" data-id="element-638">
              <div className="flex items-center gap-3 mb-4" data-id="element-639">
                <span className="text-2xl" data-id="element-640">🇳🇬</span>
                <ArrowRightIcon className="h-4 w-4 text-gold" data-id="element-641" />
                <span className="text-2xl" data-id="element-642">🇬🇭</span>
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-3" data-id="element-643">
                Nigeria — Ghana
              </h3>
              <p className="font-sans text-sm text-text-muted leading-relaxed mb-4" data-id="element-644">
                The ECOWAS corridor connecting West Africa's two largest
                anglophone economies. Critical for companies seeking a
                dual-market strategy.
              </p>
              <div className="pt-4 border-t border-gray-100" data-id="element-645">
                <div className="font-serif text-2xl text-navy font-bold" data-id="element-646">
                  $3.2B
                </div>
                <div className="font-sans text-xs text-gray-500" data-id="element-647">
                  Annual Bilateral Trade
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-navy text-white text-center px-4 sm:px-6 lg:px-8" data-id="element-648">
        <div className="max-w-3xl mx-auto" data-id="element-649">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8" data-id="element-650">
            Explore Your Market Entry Strategy
          </h2>
          <p className="font-sans text-lg text-white/80 mb-10" data-id="element-651">
            Our regional experts are ready to help you identify the right entry
            point and build a strategy tailored to your sector.
          </p>
          <Link to="/inquiry" className="inline-block bg-gold hover:bg-gold-light text-navy font-sans font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-card transition-colors shadow-lg" data-id="element-652">
            Request a Regional Briefing
          </Link>
        </div>
      </section>
    </div>;
}